"use client";
import React, { useEffect, useState } from "react";
import HeroBanner from "../home-six/HeroBanner";
import FooterFive from "@/layouts/footers/FooterFive";
import axiosInstance from "@/service/axiosInstance";
import Loader from "@/components/Loader/Loader";
import ContactArea from "@/components/contact-area";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import { useDispatch } from "react-redux";
import { FooterLinkType, PageName, SectionType } from "@/utils/enum";

const Page = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [bannerData, setbannerData] = useState([]);
  const [footerData, setFooterData] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);

  function getSortedSections(data: any, section: any) {
    return data
      .filter((item: any) => item.attributes.Section === section)
      .sort((a: any, b: any) => a.attributes.Sequence - b.attributes.Sequence)
      .map((item: any) => ({
        id: item.id,
        scetion: item.attributes.Section,
        page: item.attributes.Page,
        type: item.attributes.Type,
        Title: item.attributes.Title,
        URL: item.attributes.URL,
        content: item.attributes.Content,
        Image_Path: item.attributes.Image_Path,
        sequence: item.attributes.Sequence,
        academicYear: item.attributes.ac_academic_year.data?.attributes.name,
      }));
  }
  const getData = async () => {
    try {
      setLoading(true);
      // const token = localStorage.getItem("token")

      const resp: any = await axiosInstance.get("/homePage", {});
      // console.log('respomsa--,',resp);

      // if (token) {
      //   if (
      //     resp?.isAuthorized?.status == 401 ||
      //     resp?.isAuthorized?.message ==
      //     "Token has expired"
      //   ) {
      //     console.log("Token has expired!");
      //     toast.error("Session expired please login again", {
      //       position: toast.POSITION.TOP_RIGHT,
      //       autoClose: 3000,
      //     });
      //     localStorage.removeItem("token");
      //     dispatch(logout());

      //     // router.push(`/login?redirect="true"`);

      //     // return;
      //   }
      // }
      // let updated = resp?.data;

      // setCount(resp?.meta.pagination.total);
      const BannerData = getSortedSections(
        resp?.data?.data,
        SectionType.BANNER,
      );

      setbannerData(BannerData);
      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        SectionType.FOOTER,
        FooterLinkType.LINK_1,
      );
      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        SectionType.FOOTER,
        FooterLinkType.LINK_2,
      );
      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        SectionType.FOOTER,
        FooterLinkType.LINK_3,
      );
      setFooterData([footerData1, footerData2, footerData3]);

      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        SectionType.SOCIAL_MEDIA,
        PageName.HOME_PAGE,
      );
      setSocialMedia(socialMediaData);

      // Create a new object containing the filtered data
      // const filteredApiResponse = { data: filteredData };

      setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <html>
        <title>Contact Us - Vibgyor Viva Event</title>
        <meta
          name="description"
          content="Get in touch with Vibgyor Viva! Have questions or need assistance? Contact us for event inquiries, support, or feedback. Our dedicated team is here to help you create unforgettable experiences. Reach out today!"
        />
      </html>
      {loading && <Loader />}
      {/* <HeaderOne style={true} /> */}
      <HeroBanner bannerData={bannerData} />
      <ContactArea />
      <FooterFive data={footerData} socialMedia={socialMedia} />
    </>
  );
};

export default Page;
